var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","fillRule":"nonzero","d":"M4.136 4.1L8.25-.016l1.276 1.277-4.114 4.114-1.371 1.37L.723 3.43l1.371-1.371z"}));
}

Check.defaultProps = {"viewBox":"0 0 10 7"};

module.exports = Check;

Check.default = Check;
